<template>
  <div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
    <page-navigate></page-navigate>
    <div class="cookies" >
      <section class="section1">
        <h1 :class="$t('common.fontFamilyTitle')">{{ $t('cookie.Cookie政策') }}</h1>
        <p class="p1">
          {{ $t('cookie.本Cookie政策说明EBCFinancial') }}
        </p>
      </section>
      <section class="section2">
        <h2 :class="$t('common.fontFamilyTitle')">{{ $t('cookie.什么是Cookie') }}</h2>
        <p class="p1">
          {{ $t('cookie.Cookie是当您浏览EBC') }}
        </p>
        <p class="p1">
          {{ $t('cookie.您可透过以下网站了解更多') }}
          <br />
          <a href="https://allaboutcookies.org/" target="_blank">www.allaboutcookies.org</a>
          <br />
          <a href="https://youronlinechoices.eu/" target="_blank">www.youronlinechoices.eu</a>
        </p>

        <h2 :class="$t('common.fontFamilyTitle')" class=" mt-120"> {{ $t('cookie.我们使用的Cookie类型') }}</h2>
        <p class="p1" v-if="$t('cookie.tabletop')">
          {{ $t('cookie.tabletop') }}
        </p>
        <div class="cookie-table">
          <div class="cookie-table-thead">
            <div class="cookie-table-td">{{ $t('cookie.Cookie类型') }}</div>
            <div class="cookie-table-td">{{ $t('cookie.说明') }}</div>
          </div>
          <div class="cookie-table-tr">
            <div class="cookie-table-td">{{ $t('cookie.必要Cookie') }}</div>
            <div class="cookie-table-td">
              {{ $t('cookie.此类Cookie是网站正常运作所必需') }}

            </div>
          </div>
          <div class="cookie-table-tr">
            <div class="cookie-table-td">{{ $t('cookie.效能分析Cookie') }}</div>
            <div class="cookie-table-td">
              {{ $t('cookie.此类Cookie协助我们计算访客数与流量来源') }}

            </div>
          </div>
          <div class="cookie-table-tr">
            <div class="cookie-table-td">{{ $t('cookie.功能性Cookie') }}</div>
            <div class="cookie-table-td">
              {{ $t('cookie.使网站能提供更进阶的功能与个人化体验') }}

            </div>
          </div>
        </div>
        <p class="p1" v-if="$t('cookie.tablebottom')">
          {{ $t('cookie.tablebottom') }}
        </p>
        <h2 :class="$t('common.fontFamilyTitle')" class=" mt-120">{{ $t('cookie.如何管理Cookie') }}</h2>
        <p class="p1">
          {{ $t('cookie.您有权决定是否接受Cookie') }}<br />
          {{ $t('cookie.查看装置上已安装的Cookie') }}<br />
          {{ $t('cookie.删除Cookie') }}<br />
          {{ $t('cookie.封锁Cookie') }}<br />
          {{ $t('cookie.设定特定网站的Cookie偏好') }}<br />
        </p>
        <p class="p1">
          {{ $t('cookie.详细操作请参阅您的浏览器说明页') }}<br />
          <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a><br />
          <a href="https://www.mozilla.org/firefox/" target="_blank">Mozilla Firefox</a><br />
          <a href="https://www.apple.com/safari/" target="_blank">Safari</a><br />
          <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a><br />
          <a href="https://www.opera.com/" target="_blank">Opera</a>
        </p>
        <h2 :class="$t('common.fontFamilyTitle')" class=" mt-120">{{ $t('cookie.同意h2') }}</h2>
        <p class="p1">
          {{ $t('cookie.当您使用本网站') }}

        </p>
        <h2 :class="$t('common.fontFamilyTitle')" class=" mt-120">{{ $t('cookie.政策更新') }}</h2>
        <p class="p1" v-html="$t('cookie.本Cookie政策可能因应实务或法律改变而更新')">

        </p>
        <p class="updatetime">{{ $t('cookie.最后更新时间') }}</p>
      </section>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
export default {

}

</script>

<style>
.cookies a {
  text-decoration: underline;
}

.cookies .a-normal {
  text-decoration: none;
  color: #666;
}

.cookies .a-normal:hover {
  color: #666;
}</style>
<style scoped>
.section1 {
  height: 333rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url("../assets/image/cookie/section1_bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}

.section1 h1 {
  color: #fff;
  text-align: center;
  font-size: 40rem;
  font-style: normal;
  font-weight: 900;
  line-height: 48rem;
}

.section1 .p1 {
  margin-top: 25rem;
  color: #fff;
  text-align: center;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: 25rem;
  /* padding: 0 180rem; */
  max-width: 960rem;
}

.section2 .p1 .b {
  font-weight: 700;
}

.section2 {
  padding: 120rem 460rem;
}

.section2 h2 {
  color: #a52933;
  /* text-align: center; */
  font-size: 36rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.section2 .p1 {
  margin-top: 38rem;
  color: #666;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.updatetime {
  margin-top: 120rem;
  color: #666;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.cookie-table {
  margin-top: 40rem;
  box-shadow: 0px 4px 9.1px 0px rgba(0, 0, 0, 0.1);
}

.cookie-table-thead {
  background: #f9f6f2;
}

.cookie-table-thead .cookie-table-td {
  display: inline-block;
  font-size: 17rem;
  font-weight: 700;
  padding: 18rem 36rem;
  color: #666;
  background: #f9f6f2;
}

.cookie-table-tr {
  display: flex;
}

.cookie-table-tr .cookie-table-td {
  display: inline-block;
  font-size: 15rem;
  padding: 18rem 36rem;
  color: #666;
  flex-shrink: 0;
  line-height: normal;
}

.cookie-table-thead .cookie-table-td:first-child,
.cookie-table-tr .cookie-table-td:first-child {
  width: calc(30% - 1px);
}

.cookie-table-thead .cookie-table-td:first-child {
  border-right: 1px solid #fff;
}

.cookie-table-thead .cookie-table-td:last-child,
.cookie-table-tr .cookie-table-td:last-child {
  width: 70%;
}

.cookie-table-tr {
  position: relative;
}

.cookie-table-tr+.cookie-table-tr::after {
  content: "";
  width: calc(100% - 40rem);
  height: 1px;
  position: absolute;
  top: 0;
  left: 20rem;
  background-color: #e5e5e5;
}

.mt-120 {
  margin-top: 120rem;
}



@media (max-width: 996px) {
  .section1 {
    background-position: right;
  }

  .section1 .p1 {
    max-width: none;
    padding: 0 28rem;
  }

  .section2 {
    padding: 100rem 65rem;
  }

  .section1 h1,
  .section2 h2 {
    font-size: 46rem;
  }

  .section1 .p1,
  .section2 .p1 {
    /* padding: 0 30rem; */
    font-size: 24rem;
    line-height: normal;
    margin-top: 40rem;
  }

  .cookie-table-thead .cookie-table-td,
  .cookie-table-tr .cookie-table-td {
    display: inline-flex;
    align-items: center;
    padding: 16rem 36rem;
  }

  .cookie-table-thead .cookie-table-td {
    height: 58rem;
    font-size: 22rem;
  }

  .cookie-table-tr .cookie-table-td {
    font-size: 20rem;
  }

  .cookie-table-thead .cookie-table-td:first-child,
  .cookie-table-tr .cookie-table-td:first-child {
    width: calc(35% - 1px);
    align-items: flex-start;
  }

  .cookie-table-thead .cookie-table-td:last-child,
  .cookie-table-tr .cookie-table-td:last-child {
    width: 65%;
  }

  .mt-120 {
    margin-top: 100rem;
  }

  .updatetime {
    font-size: 24rem;
    margin-top: 100rem;
  }
}
</style>